// extracted by mini-css-extract-plugin
export default {"reverseSpinner":"loader_reverseSpinner__XY5Z0","spin":"loader_spin__RAlyV","spinBack":"loader_spinBack__vN4uV"};